import Swal from 'sweetalert2';

export const PopupNotification = ({
  action,
  value,
  type = 'success', // success | error | warning | info
  timer = 2500,
  showConfirmButton = false,
  position = 'center'
}) => {
  const titles = {
    success: {
      add: 'Added!',
      edit: 'Updated!',
      delete: 'Deleted!',
      redeem: 'Redeemed!'
    },
    error: {
      add: 'Failed to Add!',
      edit: 'Failed to Update!',
      delete: 'Failed to Delete!',
      redeem: 'Failed to Redeemed!'
    },
    warning: {
      default: 'Warning!'
    },
    info: {
      default: 'Information'
    }
  };

  // Determine correct modal title text
  const title = titles[type]?.[action] || titles[type]?.default || (type === 'success' ? 'Success!' : 'Error!');

  // Determine content message
  const message = type === 'success' ? `${value}.` : type === 'warning' ? value : `${value}.`;

  // Swal.fire({
  //   icon: type,
  //   title,
  //   text: message,
  //   timer,
  //   showConfirmButton,
  //   position,
  //   toast: position !== 'center',
  //   background: 'var(--popup-bg, #ffffff)',
  //   color: 'var(--popup-text, #111)',
  //   buttonsStyling: false,
  //   customClass: {
  //     popup: 'popup-custom swal-high-zindex dark:bg-gray-900 dark:text-white',
  //     title: 'font-semibold'
  //   },
  //   didOpen: () => {
  //     const icon = document.querySelector('.swal2-icon');
  //     if (icon) icon.style.transform = 'scale(0.8)';
  //   }
  // });

  Swal.fire({
    icon: type,
    title,
    text: message,
    timer,
    showConfirmButton,
    position,
    toast: position !== 'center',

    width: '300px',

    background: 'var(--popup-bg, #ffffff)',
    color: 'var(--popup-text, #111)',

    buttonsStyling: false,

    customClass: {
      popup: 'popup-custom swal-high-zindex',
      title: 'text-sm font-semibold'
      // htmlContainer: 'text-xs' // 👈 smaller content
    },

    didOpen: () => {
      const icon = document.querySelector('.swal2-icon');
      if (icon) icon.style.transform = 'scale(0.5)';
    }
  });
};

// Service API

export const notify = {
  success: (value, action = 'add') => PopupNotification({ type: 'success', value, action }),

  error: (value, action = 'add') => PopupNotification({ type: 'error', value, action, timer: 1800 }),

  warning: (value) => PopupNotification({ type: 'warning', value, timer: 2000 }),

  info: (value) => PopupNotification({ type: 'info', value, timer: 2000 })
};
